import { performRequestThird } from 'common/apiHandler';
import { default as apiEndPoints } from 'common/apiEndPoints';
import Cookies from 'universal-cookie';

const cookie = new Cookies();

const getTenantDetails = () => {
  const tenantId = cookie.get('tenantId') || null;
  const tenant_sk = cookie.get('tenantSk') || null;
  let tenantSk = tenant_sk ? tenant_sk.replace('#', '%23') : '';
  return [tenantId, tenantSk];
};

/**
 * Get CaptureNow integration ID for the tenant
 * @returns {Promise} API response
 */
export const getCaptureNowIntegrationId = () => {
  const [tenantId] = getTenantDetails();
  if (!tenantId) {
    return Promise.reject(new Error('Tenant ID not found'));
  }

  return performRequestThird(apiEndPoints.methodType.GET, `${apiEndPoints.mapCaptureNowTenant}?tenant_id=${tenantId}`);
};

/**
 * Generate new CaptureNow integration ID for the tenant
 * @returns {Promise} API response
 */
export const generateCaptureNowIntegrationId = () => {
  const [tenantId] = getTenantDetails();
  if (!tenantId) {
    return Promise.reject(new Error('Tenant ID not found'));
  }

  return performRequestThird(
    apiEndPoints.methodType.GET,
    `${apiEndPoints.mapCaptureNowTenant}?tenant_id=${tenantId}&generate_integration_id=true`
  );
};
